export default __webpack_public_path__ + "images/68b7eb3047721ba39804d75892051cfc-blues.jpg";